export const LOG = {
    PLAY_ANIMATION: 'Play',
    BONES: '🦴 Bones attached',
    TEXT: `🦴 Texts attached`,
    BUTTONS: `⬇️ Buttons attached`,
    SPINES: `𖠣 Spines added`,
    STATES: `🎬 States added`,
    STATE: '🎬 Play State',
    EVENTS: `⚡ Events registered`,
    SPINE_EVENTS: `⚡ Spine events available`,
    EVENT: `⚡ Play event`,
    ANIMATIONS: `⚡ Animations added`,
    ADD_SLOT_CHILD: `🧩 Add slot child`,
};
